import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Walkers.css";
import RegistrationModal2 from "../../components/RegistrationModal2";

const Walkers = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <>
      <section className="services-page">

        {/* Banner */}
        <div className="service-banner">
          <div className="overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h1>Services</h1>
                <p>Regular exercise and outdoor adventures for your dog</p>
              </div>

              <div className="col-lg-6 text-end">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
                  alt="Pets"
                  className="img-fluid banner-pets"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Service Card */}
        <div className="service-section">
          <div className="container">

            <div className="service-card">
              <div className="row">
                <div className="col-md-5">
                  <div className="service-content">
                    <h1 className="font-bold mb-4">
                      Walkers
                    </h1>
                    <p className="font-semibold">
                      Regular exercise and outdoor adventures for your dog with our trusted pet walking services. Perfect for busy pet parents who want to ensure their dogs get the activity they need.
                    </p>
                    <p>
                      Our verified dog walkers provide safe, enjoyable walks tailored to your dog's energy level and preferences, with real-time tracking and updates.
                    </p>
                    <a className="btn btn-dark rounded-pill px-4 w-mxcontent mt-4 font-semibold py-2" data-bs-toggle="modal" data-bs-target="#RegistrationModal2">
                      Join Us Now
                    </a>
                  </div>
                </div>
                <div className="col-md-7 pe-0">
                  <div className="service-image">
                    <img
                       className="img-fluid dog-image"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/service_img/walkers.jpeg`}
                      alt="Veterinary Services"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Registration Modal 2 for Service Providers */}
        <RegistrationModal2 preSelectedService="walking" />
      </section>
    </>
  );
};

export default Walkers;
